import { fg } from '@atlaskit/platform-feature-flags/fg';

import type { SegmentBatchDef } from './types';

const REQUEST_COMPRESSION_GATE = 'analytics-web-client-request-compression';

const gzip = async (body: string): Promise<Blob | undefined> => {
	try {
		// Feature-detected below; the compat data lags browsers that support CompressionStream.
		// eslint-disable-next-line compat/compat
		const reader = new Blob([body]).stream().pipeThrough(new CompressionStream('gzip')).getReader();
		const chunks: Uint8Array<ArrayBuffer>[] = [];

		for (let next = await reader.read(); !next.done; next = await reader.read()) {
			chunks.push(next.value as Uint8Array<ArrayBuffer>);
		}

		return new Blob(chunks);
	} catch {
		return undefined;
	}
};

export const createRequestPayload = async (
	batch: SegmentBatchDef,
): Promise<{ body: string | Blob; headers: Record<string, string> }> => {
	const body = JSON.stringify(batch);
	const compressedBody =
		fg(REQUEST_COMPRESSION_GATE) && typeof CompressionStream !== 'undefined'
			? await gzip(body)
			: undefined;

	return {
		// Plain requests avoid preflights. Compressed requests also require CORS to allow Content-Encoding.
		headers: {
			'Content-Type': 'text/plain',
			...(compressedBody ? { 'Content-Encoding': 'gzip' } : {}),
		},
		body: compressedBody ?? body,
	};
};
